const NAMESPACE = "addInquiry";

const KEYS = {
    submittingMessage: "submittingMessage",
    loadingInfoMessage: "loadingInfoMessage",
    loadingLookupMessage: "loadingLookupMessage",
    isProjectRelatedText: "isProjectRelatedText",
    relatedOptionText: "relatedOptionText",
    notRelatedOptionText: "notRelatedOptionText",
    projectSelectorLabel: "projectSelectorLabel",
    selectPlaceholder: "selectPlaceholder",
    lookupDataHeader: "lookupDataHeader",
    dataUnavailableText: "dataUnavailableText",
    categorySelectorLabel: "categorySelectorLabel",
    questionTitleLabel: "questionTitleLabel",
    questionDetailLabel: "questionDetailLabel",
    remainingCharMsg: "remainingCharMsg",
    generalQuestionHeader: "generalQuestionHeader",
    supportWebsiteHeader: "supportWebsiteHeader",
    supportEmailHeader: "supportEmailHeader",
    supportPhoneHeader: "supportPhoneHeader",
    noSupportInfoText: "noSupportInfoText",
    inquirySubmittedMessage: "inquirySubmittedMessage",
    landingPageLinkLeadin: "landingPageLinkLeadin",
    landingPageLinkText: "landingPageLinkText",
    cancelButtonText: "cancelButtonText",
    submitButtonText: "submitButtonText",
    okButtonText: "okButtonText",
    invalidProjectMessage: "invalidProjectMessage",
    invalidCategoryMessage: "invalidCategoryMessage",
    invalidTitleMessage: "invalidTitleMessage",
    invalidContentMessage: "invalidContentMessage",
    enableSmsNotificationsLabel: "enableSmsNotificationsLabel"
};

const MESSAGES = {
    [KEYS.submittingMessage]: {
        value: "Submitting your inquiry...",
        comment: "Loader message for submitting"
    },
    [KEYS.loadingInfoMessage]: {
        value: "Loading...",
        comment: "Loader message for loading info"
    },
    [KEYS.loadingLookupMessage]: {
        value: "Loading info...",
        comment: "Loader message for loading lookup"
    },
    [KEYS.isProjectRelatedText]: {
        value: "Is your question related to a specific project?",
        comment: "Text for the project related selector"
    },
    [KEYS.relatedOptionText]: {
        value: "Yes",
        comment: "Question is related to a project"
    },
    [KEYS.notRelatedOptionText]: {
        value: "No",
        comment: "Question is not related to a project"
    },
    [KEYS.projectSelectorLabel]: {
        value: "Which project do you have a question about?",
        comment: "Label for the project selector"
    },
    [KEYS.selectPlaceholder]: {
        value: "Select...",
        comment: "Placeholder for dropdowns"
    },
    [KEYS.lookupDataHeader]: {
        value: "{lookupField} data for project {projectNumber}:",
        comment: "Header for the lookup data"
    },
    [KEYS.dataUnavailableText]: {
        value: "Unavailable",
        comment: "No lookup data available"
    },
    [KEYS.categorySelectorLabel]: {
        value: "Which of these categories best describes your question?",
        comment: "Label for the category selector"
    },
    [KEYS.questionTitleLabel]: {
        value: "Enter a title for your question:",
        comment: "Label for the question title entry"
    },
    [KEYS.questionDetailLabel]: {
        value: "Please describe your question in detail:",
        comment: "Label for the question detail entry"
    },
    [KEYS.remainingCharMsg]: {
        value: "Remaining Characters: {charactersRemaining}",
        comment: "Message for alerting user how many allowed characters are left."
    },
    [KEYS.generalQuestionHeader]: {
        value: "Do you have a general question about this program?",
        comment: "Header for the non-project specific route"
    },
    [KEYS.supportWebsiteHeader]: {
        value: "Visit our support site:",
        comment: "Header for the support website"
    },
    [KEYS.supportEmailHeader]: {
        value: "Email our support address:",
        comment: "Header for the support email"
    },
    [KEYS.supportPhoneHeader]: {
        value: "Call our support line:",
        comment: "Header for the support phone"
    },
    [KEYS.noSupportInfoText]: {
        value: "Please contact a program administrator for assistance.",
        comment: "No support fields available"
    },
    [KEYS.inquirySubmittedMessage]: {
        value: 'Thank you! Your inquiry "{inquiryTitle}" has been submitted.',
        comment: "Inquiry submitted message"
    },
    [KEYS.landingPageLinkLeadin]: {
        value: "You can view this inquiry thread on ",
        comment: "Leadin to the landing page link"
    },
    [KEYS.landingPageLinkText]: {
        value: "the project view/edit page for project {projectNumber}.",
        comment: "Landing page link text"
    },
    [KEYS.cancelButtonText]: {
        value: "Cancel",
        comment: "Cancel button text"
    },
    [KEYS.submitButtonText]: {
        value: "Submit Question",
        comment: "Submit button text"
    },
    [KEYS.okButtonText]: {
        value: "OK",
        comment: "OK button text"
    },
    [KEYS.invalidProjectMessage]: {
        value: "Please select a project.",
        comment: "No project selected"
    },
    [KEYS.invalidCategoryMessage]: {
        value: "Please select a category.",
        comment: "No category selected"
    },
    [KEYS.invalidTitleMessage]: {
        value: "Title cannot be blank.",
        comment: "Missing title"
    },
    [KEYS.invalidContentMessage]: {
        value: "Detail cannot be blank.",
        comment: "Missing content"
    },
    [KEYS.enableSmsNotificationsLabel]: {
        value: "Enable SMS notifications for this inquiry thread",
        comment: "Enable Sms notifications checkbox"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
